import './styles/default.scss';
import { getText } from '@/utils/text/text';
import { formatPlayerCount } from '@/app/components/badge/layouts/social-tag/utils/social-tag-utils';
import { SvgLoader } from '@/app/elements/svg/loader';
import { classes } from '@/utils/classes/classes';

type SocialTagBadgeProps = {
    uniquePlayersCount?: number;
    state?: 'hot' | 'cold';
    hidePlayingText?: boolean;
};

export const SocialTagBadge: React.FC<SocialTagBadgeProps> = ({
    uniquePlayersCount,
    state,
    hidePlayingText = false
}) => {
    if (!state || !uniquePlayersCount || uniquePlayersCount <= 0) {
        return null;
    }

    return (
        <div
            className={classes('social-tag-badge', `status-${state}`, hidePlayingText && 'minified')}
            data-testid="social-tag-badge">
            <SvgLoader iconName="social-tag" className="social-tag-badge__icon" />
            <div className="social-tag-badge__count">
                <p className="social-tag-badge__count__text">
                    <span className="social-tag-badge__count__text__number">
                        {formatPlayerCount(uniquePlayersCount)}
                    </span>
                    {!hidePlayingText && (
                        <span className="social-tag-badge__count__text__playing">
                            {getText({ text: 'components.socialTagBadge.playing' })}
                        </span>
                    )}
                </p>
            </div>
        </div>
    );
};
